<mat-toolbar class="primary">
  <span class="adx-title">{{ appName }}</span>
</mat-toolbar>
